import React from "react";
import { Box, Text, useColorModeValue } from "@chakra-ui/react";

const PJ = "'Plus Jakarta Sans', sans-serif";

export default function About() {
  const bodyColor = useColorModeValue("#444444", "#999999");

  return (
    <Box as="section" pt="55px" pb="10px" textAlign="center">
      {/* Bio */}
      <Text
        fontFamily={PJ}
        fontSize="17px"
        color={bodyColor}
        lineHeight="1.9"
        mb={8}
        maxW="460px"
        mx="auto"
      >
        Hello, I&apos;m Huy Phu — a Senior QA Engineer and Security Engineer
        based in Los Angeles, California. Currently working on raising
        awareness in Security while using AI.
      </Text>
    </Box>
  );
}
